// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\GoogleCalendarResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type GoogleCalendarApiResponse = {
	id: number;
	calendarId: string | null;
	channelId: string | null;
	resourceId: string | null;
	expiration: string | null;
	syncToken: string | null;
	areaId: string | null;
	googleAuthId: number | null;
};

export type GoogleCalendar = {
	id: number;
	calendarId: string | null;
	channelId: string | null;
	resourceId: string | null;
	expiration: DateTime | null;
	syncToken: string | null;
	areaId: string | null;
	googleAuthId: number | null;
};

export function hydrateGoogleCalendar(data: GoogleCalendarApiResponse): GoogleCalendar {
	return {
		...data,
		expiration: DateTimefromISO(data.expiration),
	};
}